import { styled } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';

export const FieldLimitAlertContainer = styled('div')({
	marginBottom: '16px'
});

export const FieldLimitErrorAlert = styled(Alert)({
	'& .MuiAlert-message': {
		fontSize: '14px',
		fontWeight: 500
	},
	marginBottom: '16px'
});

export const ToolbarContainer = styled('div')<{ disabled: boolean }>(({ disabled }) => ({
	display: 'sticky',
	opacity: disabled ? 0.6 : 1,
	pointerEvents: disabled ? 'none' : 'auto'
}));

export const DisabledToolboxContainer = styled('div')<{ disabled: boolean }>(({ disabled }) => ({
	opacity: disabled ? 0.6 : 1,
	pointerEvents: 'auto',
	position: 'relative'
}));

export const CursorTooltip = styled(Tooltip)(({ theme }) => ({
	'& .MuiTooltip-tooltip': {
		fontSize: '12px',
		backgroundColor: theme.palette.grey[800],
		color: theme.palette.common.white,
		border: `1px solid ${theme.palette.grey[600]}`,
		borderRadius: '4px',
		padding: '6px 8px',
		maxWidth: 200,
		textAlign: 'center'
	},
	'& .MuiTooltip-arrow': {
		color: theme.palette.grey[800]
	}
}));
